import type { StoreName } from './schema'

/**
 * Minimal write-notification bus.
 *
 * Repositories announce which stores they wrote; views subscribe and refetch.
 * This replaces a reactive query library — D-025 rejected one because the app
 * has no network cache to reconcile and the data volume is tiny.
 */
type Listener = (stores: ReadonlySet<StoreName>) => void

const listeners = new Set<Listener>()

export function subscribe(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function notifyWritten(...stores: readonly StoreName[]): void {
  if (stores.length === 0) return
  const changed: ReadonlySet<StoreName> = new Set(stores)
  // Copy first: a listener may unsubscribe during iteration.
  for (const listener of Array.from(listeners)) {
    listener(changed)
  }
}

/** Test helper. Not used by application code. */
export function resetListeners(): void {
  listeners.clear()
}
